import { render, staticRenderFns } from "./JobOrderShow.vue?vue&type=template&id=2504b3b1&"
import script from "./JobOrderShow.vue?vue&type=script&lang=js&"
export * from "./JobOrderShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports